var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokMobileRecord = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 49,
  viewBox: "0 0 49 49",
  role: "img"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "78.251%",
  x2: "21.935%",
  y1: "90.998%",
  y2: "8.811%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#4D4D4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "49.969%",
  stopColor: "#1F1F1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#666"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 24.5,
  r: 24.5,
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 24.5,
  r: 6,
  fill: "#E5BD16"
}))));
export default SvgTiktokMobileRecord;